import React from 'react';
import { useTranslation } from 'react-i18next';
import { newDeviceProps } from '@modules/devices/types/types-devices';

type ListDeviceProps = {
  devices: Array<newDeviceProps>
}

const ListDevices = ({devices}: ListDeviceProps) => {
  //TODO TABLE COMPONENT HERE
  const { t } = useTranslation(['myDevices']);
  return (
    <>
      {/*make component this table*/}
      <div className="Services__Table">
        <div className="Services__TableHeader">
          <p className="Services__TableHeaderItem"
            // onClick={() => sort('name')}
          >
            {t('table.id')}
            <span>
              <em className="fad fa-sort-amount-up"/>
              {/*<em className={nameSort ? "fad fa-sort-amount-up" : "fad fa-sort-amount-down"} />*/}
            </span>
          </p>
          <div
            // onClick={() => sort('next')}
            className="Services__TableHeaderItem3"
          >
            {t('table.devices')}
            <span>
                  <em className="fad fa-sort-amount-up"/>
              {/*<em className={nextAppointSort ? "fad fa-sort-amount-up" : "fad fa-sort-amount-down"} />*/}
            </span>
          </div>
          <div
            // onClick={() => sort('last')}
            className="Services__TableHeaderItem4"
          >
            {t('table.room')}
            <span>
                <em className="fad fa-sort-amount-up"/>
              {/*<em className={lastAppointSort ? "fad fa-sort-amount-up" : "fad fa-sort-amount-down"} />*/}
            </span>
          </div>
          <div
            // onClick={() => sort('last')}
            className="Services__TableHeaderItem4"
          >
            {t('table.serialN')}
          </div>
          <div
            // onClick={() => sort('last')}
            className="Services__TableHeaderItem4"
          >
          </div>
          <div
            // onClick={() => sort('last')}
            className="Services__TableHeaderItem4"
          >
          </div>
        </div>



      </div>
    </>
  );
};

export default ListDevices;
